module.exports = __webpack_public_path__ + "static/media/ask_for_everything@2x.f248bdad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/ask_for_everything@2x.png
// module id = 1083
// module chunks = 50